import Header from "../../components/Header/Header";
import iconTel2 from "../../assets/icon_tel2.svg";
import iconHome from "../../assets/icon_home.svg";
import iconBarcode from "../../assets/icon_barcode.svg";

import { Accordion, AccordionItem } from "@szhsin/react-accordion";

import useSelectBrandId from "#features/Giftcard/hooks/useSelectBrand";
import useSelectBrand from "#hooks/styles/useSelectBrand";
import useReactGASend from "../../hooks/useReactGASend";

const nobrand = [
  {
    title: "노브랜드 상품권 안내",
    content:
      "노브랜드에서는 신세계상품권 이용 가능하나 단, 현금없는 매장에서는 사용이 불가 합니다. 상품권을 SSGPAY앱을 통해 SSG머니로 전환하여 모바일로 사용 가능합니다.",
    reference:
      "* 노브랜드에서는 상품권 구매 및 교환 등 관련 업무를 진행하지 않으니 가까운 이마트/트레이더스를 이용하여 주시기 바랍니다.",
  },
];

const everyday = [
  {
    title: "에브리데이 상품권 안내",
    content:
      "에브리데이에서는 신세계상품권 지류만 사용이 가능합니다. 모바일 상품권 사용 불가합니다. 에브리데이에서는 상품권 판매를 진행하고 있지 않습니다. 가까운 이마트/트레이더스를 이용하여 주시기 바랍니다.",
    reference:
      "* 상품권 판매점포 : 이수점, 광명점, 이문점 [3개점]",
  },
  {
    title: "사용가능 상품권 안내",
    content:
      "신세계 상품권만 사용 가능하며 계산대에서 현금처럼(포인트 및 현금 영수증 적립 가능) 이용 가능합니다. 단 모바일 신세계 상품권은 사용이 가능하지 않고 지류 상품권으로 전환 후 사용 가능합니다. 이외 도서상품권 및 문화상품권, 지역사랑 상품권, 온누리상품권 등은 사용 불가능합니다",
    reference:
      "",
  },
  {
    title: "상품권 거스름 안내",
    content:
      "액면가 대비 60% 이상 사용하신 경우에 한하여 그 잔액을 현금으로 돌려드리고 있습니다. 단, 1만원권 이하 상품권의 경우 액면가 대비 80% 이상을 사용하신 경우에 한하여 그 잔액을 현금으로 돌려드리고 있습니다. 기준 이하로 사용하신 경우에는 신세계 상품권으로 잔액을 지급하고 있습니다",
    reference:
      "",
  },
  {
    title: "상품권 권종 및 SSG머니 교환 안내",
    content:
      "신세계 상품권은 5천원, 1만원, 5만원, 10만원, 30만원, 50만원권이 있습니다. SSG 머니로 충전할 수 있는 스크래치 상품권은 2가지의 권종으로 5만 원권, 10만 원권 권이 있습니다. 스크래치를 긁은 후 SSG MONEY 전환하여 사용할 수 있습니다",
    reference:
      "",
  },
  {
    title: "모바일 상품권 구매 방법",
    content:
      "에브리데이에서는 모바일 상품권을 판매하지 않습니다. SSG.COM등 인터넷을 통해 구매 가능하십니다",
    reference:
      "",
  },
  {
    title: "모바일 상품권 교환 방법",
    content:
      "에브리데이에서는 일부점에서만 모바일 상품권을 종이 상품권으로 교환이 가능하며 이외 지역에서는  가까운 이마트/트레이더스 매장을 방문하여 키오스크를 이용하여 주시기 바랍니다.단, 이마트로 명시된 모바일 상품권만 가능하며 유효기간 내 교환 부탁드립니다.",
    reference:
      "*신세계백화점으로만 명시 시 이마트에서 교환 불가 \n\n *상품권 교환 가능 점포 : 가양역,거제상동,거제수월,경서,고양지축,고흥,광사,광명,김포자이,나주혁신,대구도남,동탄목동,동탄카림,동탄호수,무안오룡,부산일광,서창2,서초내곡,서충주,서판교,성주,수원태장,신탄진,양주옥정,오션시티,오창산단,이수,이문,인천SK,인천송도,인천영종,임실,장현,진량,진천옥동,창원북면,포항양덕,홍성내포,흑석",
  },
];

const shinsegae = [
  {
    title: "신세계 상품권 구매 방법",
    content:
      "상품권 키오스크에서 신세계 상품권만 구매 가능하며 1회 500만 원까지 구매 가능하며 현금, 현금 IC 칩 카드, 법인카드로만 구매 가능합니다.(계좌이체 불가) 액면가로 판매하고 있으며 SSG.COM을 통해 구매 후 이마트 매장 키오스크에서 전환도 가능합니다",
    reference:
      "* 단 개인 신용카드 결제는 불가하며 수표로 구매시 100만원 이하 거래만 가능하며 고객만족 센터에 문의해 주시기 바랍니다",
  },
  {
    title: "법인카드 상품권 구매 방법",
    content:
      "법인카드 상품권 구매 시 가까운 매장 상품권 키오스크에서 별도 서류 없이 사업자 번호+법인카드 비밀번호 입력 시 구매 가능합니다. 키오스크에서 500만 원까지 구매 가능하며 다량 구매 시에는 상품권샵에 문의해 주시기 바랍니다",
    reference:
      "* 단, 법인카드 명의가 대표자명(개인)으로 되어있다면 해당 본인만 구매 가능하며 생년월일+법인카드 비밀번호가 필요하며 유가증권 구매한도를 확인 후 구매해 주시기 바랍니다",
  },
];

const common = [
  {
    title: "사용가능 상품권 안내",
    content:
      "신세계 상품권 및 국민관광 상품권 사용 가능 하며 계산대에서 현금처럼 사용이 가능합니다. 상품권으로 결제 시 포인트 적립 및 현금영수증이 가능하며 셀프계산대에서는 상품권 결제가 불가합니다. 단, 도서상품권 및 문화상품권, 지역사랑 상품권, 온누리상품권 등은 불가능합니다",
    reference: "* 노브랜드 현금없는 매장에서는 모든 상품권 사용이 불가 합니다",
  },
  {
    title: "상품권 거스름 안내",
    content:
      "액면가 대비 60% 이상 사용하신 경우에 한하여 그 잔액을 현금으로 돌려드리고 있습니다. 단, 1만원권 이하 상품권의 경우 액면가 대비 80% 이상을 사용하신 경우에 한하여 그 잔액을 현금으로 돌려드리고 있습니다. 기준 이하로 사용하신 경우에는 신세계 상품권으로 잔액을 지급하고 있습니다",
    reference: "* 상품권을 현금으로 교환은 불가 합니다",
  },
  {
    title: "상품권 권종 및 SSG머니 교환 안내",
    content:
      "신세계 상품권은 1천 원, 2천 원, 5천 원, 1만 원, 5만 원, 10만 원, 30만 원, 50만 원권이 있습니다. SSG 머니로 충전할 수 있는 스크래치 상품권은 2가지의 권종으로 5만 원권, 10만 원권 권이 있습니다. 스크래치를 긁은 후 SSG MONEY 전환하여 사용할 수 있습니다",
    reference:
      "* 일반 상품권을 스크래치 상품권으로 교환 시 고객만족센터에 문의해 주시기 바랍니다",
  },
  {
    title: "모바일 상품권 구매 방법",
    content:
      "SSG.com에서 ‘신세계 상품권’ 검색하셔서 구매 가능하며, 기타 모바일 교환권 발행 업체에서도 구매 가능합니다. 이마트 및 트레이더스 매장에서는 지류상품권만 판매하며 모바일 상품권은 판매하지 않습니다",
    reference: "",
  },
  {
    title: "모바일 상품권 교환 방법",
    content:
      "모바일 상품권 교환은 가까운 이마트/트레이더스 매장을 방문하여 키오스크를 이용하여 주시기 바랍니다.(노브랜드 불가) 단, 이마트로 명시된 모바일 상품권만 가능하며 유효기간 내 교환 부탁드립니다.",
    reference: "* 신세계백화점으로만 명시 시 이마트에서 교환 불가",
  },
  {
    title: "모바일 상품권 유효기간 경과시",
    content:
      "모바일 상품권의 경우 이마트는 단순 교환처로 판매/사용 조회 및 유효기간 확인/연장 및 재발행이 불가능합니다. 모바일 상품권 하단의 유효기간을 확인해 주시기 바라며 자세한 문의는 발행한 발송처로 문의해 주시기 바랍니다",
    reference: "",
  },
];

export const AccordionItemComponent = ({
  item,
  color,
  index,
  initialEntered,
  onClick,
}) => (
  <AccordionItem
    key={index}
    className="mb-2"
    onClick={onClick}
    header={
      <div className="flex items-center w-full pb-2 text-lg font-medium text-neutral-800">
        <span
          className={`inline-flex items-center justify-center w-[42px] h-10 bg-${color} shadow-md rounded-[14px] text-neutral-600 text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
    {...(initialEntered && { initialEntered: true })}
  >
    <div className="px-6 py-3.5 border rounded-custom-reverse border-violet-50">
      <p className="font-medium text-neutral-500">{item.content}</p>

      {item.reference && (
        <p className="mt-6 text-purple-500 whitespace-pre-line">{item.reference}</p>
      )}
    </div>
  </AccordionItem>
);

export const LinkButton = ({
  href,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
    onClick={onClick}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

const GiftCardPage = () => {
  const { brandId } = useSelectBrandId();
  const { color } = useSelectBrand();
  const brandSpecificItems = brandId === "NB" ? nobrand : brandId === "ED" ? everyday : shinsegae;
  const brandSpecificTitles = new Set(brandSpecificItems.map(item => item.title));
  const filteredCommon = common.filter(item => !brandSpecificTitles.has(item.title));
  const combinedItems = [...brandSpecificItems, ...filteredCommon];

  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="상품권" />
      <h2 className="pt-10 mb-8 text-3xl font-semibold">상품권 안내</h2>

      <Accordion transition transitionTimeout={250}>
        {combinedItems.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            color={color}
            index={index}
            initialEntered={index === 0}
            onClick={() => trackButtonClick(item.title)}
          />
        ))}
        {/* {common.map((item, index) => {
          return ((
          <AccordionItemComponent
            key={index}
            item={item}
            color={color}
            index={index}
            onClick={() => trackButtonClick(item.title)}
          />
        ))})} */}
      </Accordion>

      <div className="flex flex-col items-end mt-10">
        <LinkButton
          href="https://www.shinsegae.com/service/membership/certificate.do"
          className="flex items-center justify-between w-52 h-11 bg-neutral-600 rounded-[30px] text-white px-6 text-sm font-medium mb-1.5"
          imgSrc={iconHome}
          altText="홈"
          buttonText="신세계 상품권 홈페이지"
          onClick={() => trackButtonClick("상품권 안내_홈페이지 클릭")}
        />
        <LinkButton
          href="https://store.emart.com/event/detail/checkEmartGiftCard.do"
          className="flex items-center justify-between w-52 h-11 bg-neutral-600 rounded-[30px] text-white px-6 text-sm font-medium mb-1.5"
          imgSrc={iconBarcode}
          altText="홈"
          buttonText="상품권 사용여부 조회"
          onClick={() => trackButtonClick("상품권 안내_사용여부 클릭")}
        />
        <LinkButton
          href="tel:02-380-5678"
          className="flex items-center justify-between w-52 h-11 border border-neutral-400 rounded-[30px] px-6 text-base font-medium"
          imgSrc={iconTel2}
          altText="전화"
          buttonText="02-380-5678"
          onClick={() => trackButtonClick("상품권 안내_전화번호 클릭")}
        />
      </div>
    </section>
  );
};

export default GiftCardPage;
